<template>
  <div class="score" v-if="app!=null && app.data !=null">
    <div class="launcher" id="score-content">
      <div @click="app.displaySettings()" id="boule" class="new-boule"><svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 -960 960 960" width="30"  style="fill: rgb(128, 151, 13);"><path d="M130.001-254.616V-300h699.998v45.384H130.001Zm0-202.692v-45.384h699.998v45.384H130.001Zm0-202.692v-45.384h699.998V-660H130.001Z"/></svg></div>
      <h1>Fin du</h1>
      <h1>quizz</h1>
      <div id="score-selector">
        <img class="line" id="line" src="line.png">
        <button id="toBonus" @click="app.closeScore()"><img src="arrows/white-arrow.png"></button>
        <h3><span id="note"></span>%</h3>
        <h2 style="font-weight:700; font-size: 15pt">Bonnes réponses</h2>
        <div id="graphique">
          <div id="triangle"></div>
        </div><br>
        <p>Total de bonnes réponses<span class="number" id="note20"></span></p>
        <p>Bonnes réponses avec indices<span class="number" id="note-indice-good"></span></p>
        <p>Total d'indices révélés<span class="number" id="note-indice"></span></p>
      </div>
    </div>

    <bonus
      v-bind:app="app"
    ></bonus>
    
    <settings
      v-bind:app="app"
    ></settings>

  </div>
</template>

<script>
import bonus from './bonus.vue'
import settings from './settings.vue';

export default {
  name: 'LevelVue',
  props: {
    app:Object
  },
  components :{
    bonus,
    settings
  }
}
</script>


